// 获取用户信息
const QUERY_CUSTOMER_INFOMATION = `
  query WebCustomerInfomation($id: ID!) {
    customer(id: $id) {
      id
      avatar
      nickname
      registered_at
      role {
        type
      }
      style {
        weight
        dress_size
        occupation
        height_inches
      }
      current_weather_city {
        name
      }
      customer_profile {
        signature
        description
      }
      customer_photo_stats {
        customer_photo_count
      }
      customer_follow_stats {
        followers_count
        following_count
      }
      perfect_closet_stats {
        product_count
      }
      received_customer_photo_like_count
    }
  }
`

// 查询用户晒单列表
const QUERY_CUSTOMER_PHOTOS = `
  query WebCustomerPhotos($id: ID!, $page: Int, $per_page: Int) {
    customer(id: $id) {
      id
      customer_photos(page: $page, per_page: $per_page) {
        id
        created_at
        customer {
          id
          avatar
          nickname
          height_inches
          city
          role {
            type
          }
          description
          is_follow
        }
        liked
        likes_count
        like_customers {
          id
          avatar
        }
        content
        share_topics {
          id
          title
          url
        }
        photos {
          mobile_url
          url
          width
          height
          stickers {
            anchor_x
            anchor_y
            degree
            product {
              id
              disabled
              type
              title
              disabled
              brand {
                id
                name
              }
              catalogue_photos(limit: 1) {
                medium_url
                giant_url
              }
              category {
                id
                name
                accessory
              }
              tote_slot
              full_price
              swappable
            }
          }
        }
        review {
          id
          content
        }
        featured
        best_featured
        incentives {
          text
          time_cash_amount
        }
        products {
          product {
            id
            disabled
            type
            title
            disabled
            brand {
              id
              name
            }
            catalogue_photos(limit: 1) {
              medium_url
              giant_url
            }
            category {
              id
              name
              accessory
            }
            tote_slot
            full_price
            swappable
          }
          product_size {
            id
            size_abbreviation
          }
        }
      }
    }
  }
`

// 获取用户的满分单品
const QUERY_CUSTOMER_PERFECT_PRODUCTS = `
  query WebCustomerPerfectProducts($id: ID!, $page: Int, $per_page: Int) {
    customer(id: $id) {
      id
      perfect_closets(page: $page, per_page: $per_page) {
        id
        product {
          id
          type
          title
          tote_slot
          disabled
          full_price
          swappable
          brand {
            id
            name
          }
          catalogue_photos(limit: 1) {
            medium_url
            giant_url
          }
          category {
            id
            name
            accessory
          }
        }
      }
    }
  }
`

// 获取用户风格相册
const QUERY_CUSTOMER_STYLE_ALBUM = `
  query WebCustomerStyleAlbum($id: ID!, $page: Int, $per_page: Int) {
    customer(id: $id) {
      id
      customer_photos(page: $page, per_page: $per_page) {
        id
        photos {
          mobile_url
          url
          width
          height
        }
        customer {
          id
          avatar
          nickname
          height_inches
          city
          role {
            type
          }
          description
          is_follow
        }
      }
    }
  }
`

export default {
  QUERY_CUSTOMER_INFOMATION,
  QUERY_CUSTOMER_PHOTOS,
  QUERY_CUSTOMER_PERFECT_PRODUCTS,
  QUERY_CUSTOMER_STYLE_ALBUM
}
